"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    defaultCategories: ()=>defaultCategories,
    DutchieStoreProvider: ()=>DutchieStoreProvider,
    useDutchieStore: ()=>useDutchieStore
});
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _ = require("../../");
const _schemaTypes = require("./schema-types");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const defaultCategories = [
    {
        title: 'specials',
        menuSection: {
            type: 'SPECIALS'
        },
        displayCategory: true
    },
    {
        title: 'staff picks',
        menuSection: {
            type: 'STAFF_PICKS'
        },
        displayCategory: true
    },
    {
        title: 'edibles',
        category: _schemaTypes.Category.Edibles,
        displayCategory: true
    },
    {
        title: 'flower',
        category: _schemaTypes.Category.Flower,
        displayCategory: true
    },
    {
        title: 'pre rolls',
        category: _schemaTypes.Category.PreRolls,
        displayCategory: true
    },
    {
        title: 'vaporizers',
        category: _schemaTypes.Category.Vaporizers,
        displayCategory: true
    },
    {
        title: 'concentrates',
        category: _schemaTypes.Category.Concentrates,
        displayCategory: true
    },
    {
        title: 'accessories',
        category: _schemaTypes.Category.Accessories,
        displayCategory: true
    },
    {
        title: 'apparel',
        category: _schemaTypes.Category.Apparel,
        displayCategory: true
    },
    {
        title: 'topicals',
        category: _schemaTypes.Category.Topicals,
        displayCategory: true
    },
    {
        title: 'cbd',
        category: _schemaTypes.Category.Cbd,
        displayCategory: true
    }
];
const DuchtieStoreContext = /*#__PURE__*/ _react.default.createContext({});
const DutchieStoreProvider = ({ children  })=>{
    const [orders, setOrders] = (0, _react.useState)([]);
    const [isBusy, setIsBusy] = (0, _react.useState)(false);
    const [menuCategories, setMenuCategories] = (0, _react.useState)(defaultCategories);
    const [menuLoading, setMenuLoading] = (0, _react.useState)([]);
    const [productListProps, setProductListProps] = (0, _react.useState)();
    const [brandFilter, setBrandFilter] = (0, _react.useState)(undefined);
    const [categoryFilter, setCategoryFilter] = (0, _react.useState)(undefined);
    const { setValue: setRetailer , value: retailer  } = (0, _.useStorageValue)('retailer');
    const { setValue: setMenuType , value: menuType  } = (0, _.useStorageValue)('menuType');
    const { setValue: setFullfillmentOption , value: fullfillmentOption  } = (0, _.useStorageValue)('fullfillmentOption');
    const { setValue: setFilters , value: filters  } = (0, _.useStorageValue)('filters');
    const { setValue: setSortByProp , value: sortByProp  } = (0, _.useStorageValue)('sortByProp');
    const { setValue: setProduct , value: product  } = (0, _.useStorageValue)('product');
    const { setValue: setCheckout , value: checkout  } = (0, _.useStorageValue)('checkout');
    const { setValue: setCustomer , value: customer  } = (0, _.useStorageValue)('customer');
    const { setValue: setShowStoreBottomSheet , value: showStoreBottomSheet  } = (0, _.useStorageValue)('showStoreBottomSheet');
    const cartItemsAmount = checkout?.items?.reduce((acc, item)=>{
        return acc + item.quantity;
    }, 0);
    (0, _react.useEffect)(()=>{
        if (!sortByProp) {
            setSortByProp({
                menuSort: {
                    key: _schemaTypes.MenuSortKey.Popular,
                    direction: _schemaTypes.SortDirection.Desc
                },
                label: 'popular first'
            });
        }
    }, []);
    return /*#__PURE__*/ _react.default.createElement(DuchtieStoreContext.Provider, {
        value: {
            retailer,
            setRetailer,
            menuType,
            setMenuType,
            fullfillmentOption,
            setFullfillmentOption,
            filters,
            setFilters,
            sortByProp,
            setSortByProp,
            product,
            setProduct,
            checkout,
            setCheckout,
            cartItemsAmount,
            setCustomer,
            customer,
            showStoreBottomSheet,
            setShowStoreBottomSheet,
            productListProps,
            setProductListProps,
            menuCategories,
            setMenuCategories,
            orders,
            setOrders,
            isBusy,
            setIsBusy,
            menuLoading,
            setMenuLoading,
            brandFilter,
            setBrandFilter,
            categoryFilter,
            setCategoryFilter
        }
    }, children);
};
const useDutchieStore = ()=>_react.default.useContext(DuchtieStoreContext);
